export function getFirstMonthOfQuarter(month: number): number {
  // month: 1..12 -> '01','04','07','10'
  const idx = Math.floor((month - 1) / 3); // 0..3
  const start = [1, 4, 7, 10][idx];
  return start
}
